<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >apps</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.modules' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <!--      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"-->
      <!--           fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">-->
      <!--        <label for="search" class="mr-8">-->
      <!--          <mat-icon class="secondary-text">search</mat-icon>-->
    <!--        </label>-->
    <!--        <mat-form-field floatLabel="never" fxFlex="1 0 auto">-->
    <!--          <input id="search" matInput #filter placeholder="{{'main.search' | translate}}">-->
  <!--        </mat-form-field>-->
<!--      </div>-->
<!-- / SEARCH -->

<button mat-raised-button
  [routerLink]="'/pages/settings/modules/detail'"
  class="add-product-button mat-white-bg my-12 mt-sm-0">
  <span>{{'add' | translate}}</span>
</button>

</div>
<!-- / HEADER -->
<!-- CONTENT CARD -->
<div class="content-card mat-white-bg">

  <mat-table class="products-table"
    #table [dataSource]="modules"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>


    <!-- Name Column -->
    <ng-container cdkColumnDef="title">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'module.title' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let module">
        <p class="text-truncate">{{module.title}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="status">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header class="status">{{'module.status' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let module" class="status">
        @if (module.status) {
          <p class="text-truncate active">{{'module.active' | translate}}</p>
        }
        @if (!module.status) {
          <p class="text-truncate">{{'module.inactive' | translate}}</p>
        }
      </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container cdkColumnDef="description">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'module.description' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let module">
        <div class="pl-description">{{module.description}}</div>
      </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container cdkColumnDef="url">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'module.url' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let module">
        @if (module.url) {
          <p class="text-truncate pointer">
            <a href="{{module.url}}" target="_blank">{{module.url}}</a>
          </p>
        }
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="edit">
      <mat-header-cell *cdkHeaderCellDef class="edit"></mat-header-cell>
      <mat-cell *cdkCellDef="let module" class="edit pointer">
        <p class="text-truncate" [routerLink]="'/pages/settings/modules/detail'" [queryParams]="{id: module.id}">
          <mat-icon>edit</mat-icon>
        </p>
      </mat-cell>
    </ng-container>

    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let platform; columns: displayedColumns;"
      class="product"
      matRipple>
    </mat-row>

  </mat-table>
  @if (modules.length === 0) {
    <div class="no-data-msg">
      <span class="mat-headline-6">{{'main.noData' | translate}}</span>
    </div>
  }

</div>
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>
